<app-spinner [fullScreen]="true" ></app-spinner>
<router-outlet></router-outlet>